import { scrollIntoView } from 'seamless-scroll-polyfill';
import classNames from 'classnames';

import useStyles from './styles';
import { IGoToTopButton } from './types';

function GoToTopButton({ className, children, onClick }: IGoToTopButton) {
  const classes = useStyles();

  const goToTop = () => {
    scrollIntoView(document.body, { behavior: 'smooth' });
    onClick && onClick();
  };

  return (
    <div className={classNames(classes.goTopContainer, className)}>
      <button className={classes.goToTop} onClick={goToTop}>
        {children}
      </button>
    </div>
  );
}
export default GoToTopButton;
